<template>
  <div style="text-align: left">
    <el-tabs v-model="activeName" type="border-card" @tab-click="handleClick" style="border-radius: 5px">
      <el-tab-pane label="基本信息" name="basic">
        <el-descriptions title="基本信息" direction="vertical" :column="6" border>
          <el-descriptions-item label="所属用户" :span="6">
            <router-link :to="{path: '/user/details', query: {id: providerOwner.customerId }}">{{providerOwner.customerId}}</router-link>
          </el-descriptions-item>
          <el-descriptions-item label="名称">{{ providerInfo.name }}</el-descriptions-item>
          <el-descriptions-item label="联系方式" :span="2">{{ providerInfo.mobile }}</el-descriptions-item>
          <el-descriptions-item label="身份证号码" :span="2">{{ providerInfo.identity }}</el-descriptions-item>
          <el-descriptions-item label="子类型" :span="1">{{ providerInfo.types == 3 ? (providerInfo.subType == 2 ? 'B类修理厂' : 'A类修理厂') : '' }}</el-descriptions-item>
          <el-descriptions-item label="当前状态">
            <el-tag size="small"
                    :type="providerInfo.status == 1 ? '' : (providerInfo.status == 2 ? 'danger' :
                    (providerInfo.status == 10 ? 'success' : 'info')) ">
              {{ providerInfo.status == 1 ? '待审核' : (providerInfo.status == 2 ? '被拒绝' :
              (providerInfo.status == 10 ? '已通过' : '已下线')) }}
            </el-tag>
          </el-descriptions-item>
          <el-descriptions-item label="账户余额" v-if="this.$store.state.CurrentUser != 'super_admin'">
            {{ providerInfo.balance / 100 }} 元
          </el-descriptions-item>

          <el-descriptions-item label="账户余额" v-else>
            <el-row>
              <el-col :span="8">
                <el-input v-model="providerInfo.balance" placeholder="账户余额"></el-input>
              </el-col>
              <el-col :span="4" :offset="1">
                <el-popconfirm
                  confirm-button-text='确认'
                  cancel-button-text='取消'
                  icon="el-icon-info"
                  icon-color="red"
                  title="确认要更改当前商家的账户余额吗？"
                  @confirm="confirmUpdateBalance"
                >
                  <el-button slot="reference" type="primary"><i class="el-icon-edit"></i> 更改</el-button>
                </el-popconfirm>
              </el-col>
            </el-row>
          </el-descriptions-item>

          <el-descriptions-item label="区域地址" :span="2">
            {{ providerInfo.province + '-' + providerInfo.city + '-' + providerInfo.district }}
          </el-descriptions-item>
          <el-descriptions-item label="详细地址" :span="2">
            {{ providerInfo.address }}
          </el-descriptions-item>
          <el-descriptions-item label="推荐码">
            {{ providerInfo.code }}
          </el-descriptions-item>
          <el-descriptions-item label="支付状态">
            {{ providerInfo.paid == 1 ? '已支付' : '未支付' }}
          </el-descriptions-item>
          <el-descriptions-item label="入驻时间" :span="2">
            {{ providerInfo.et }}
          </el-descriptions-item>
          <el-descriptions-item label="操作" :span="2">
            <div v-if="providerInfo.status > 0 && this.$store.state.CurrentUser != 'reader'">
              <el-popconfirm
                confirm-button-text='确认'
                cancel-button-text='取消'
                icon="el-icon-info"
                icon-color="red"
                title="确认下线当前商家吗？"
                @confirm="confirmOffline"
              >
                <el-button slot="reference" type="warning"><i class="el-icon-bottom"></i> 下线</el-button>
              </el-popconfirm>
            </div>
            <div v-else>
              #
            </div>
          </el-descriptions-item>
        </el-descriptions>

        <h5 style="margin: 20px 0px" v-if="providerInfo.status == '1' && this.$store.state.CurrentUser != 'reader'">审核</h5>
        <el-form ref="form" :model="auditForm" label-width="80px"
                 v-if="providerInfo.status == '1' && this.$store.state.CurrentUser != 'reader'">
          <el-form-item>
            <el-row>
              <el-col :span="2">支付方式</el-col>
              <el-col :span="14">
                <el-radio-group v-model="auditForm.payType">
                  <el-radio label="1">不支付</el-radio>
                </el-radio-group>
              </el-col>
            </el-row>
          </el-form-item>
          <el-form-item v-if="providerInfo.types == 3">
            <el-row>
              <el-col :span="2">服务类型</el-col>
              <el-col :span="14">
                <el-radio-group v-model="auditForm.subType">
                   <el-radio label="1">保养洗车</el-radio>
                  <el-radio label="3">只洗车</el-radio>
                </el-radio-group>
              </el-col>
            </el-row>
          </el-form-item>
          <el-form-item>
            <el-row>
              <el-col :span="2">备注</el-col>
              <el-col :span="6">
                <el-input
                  type="textarea"
                  :rows="2"
                  placeholder="请输入备注"
                  v-model="auditForm.comment">
                </el-input>
              </el-col>
            </el-row>
          </el-form-item>
          <el-form-item>
            <el-row>
              <el-col :span="2">操作</el-col>
              <el-col :span="4">
                <el-radio-group v-model="auditForm.approve">
                  <el-radio label="0">驳回</el-radio>
                  <el-radio label="1">通过</el-radio>
                </el-radio-group>
              </el-col>
              <el-col :offset="6" :span="2">
                <el-button type="primary" @click="onAudit">审核</el-button>
              </el-col>
            </el-row>
          </el-form-item>
        </el-form>

        <h5 style="margin: 20px 0px">其它信息</h5>
        <div v-for="(item, _) in imageList">
          <h6 style="margin-top: 20px">{{ imageTypes[item.types] ? imageTypes[item.types] : '其它' }}:</h6>
          <el-image :src="item.url" lazy fit="scale-down"></el-image>
        </div>
        <div v-if="imageList.length == 0">
          <p>空</p>
        </div>
      </el-tab-pane>

      <el-tab-pane label="运营数据" name="income-details">
        <operation-data :provider-id="id"
                        :maintains="maintains"
                        :total-maintain-elements="totalMaintainElements"
                        :cost-info="costInfo"
                        :incomes="incomes"
                        :total-incomes-elements="totalIncomesElements"
                        v-on:maintainListPageChange="onMaintainListPageChange"
                        v-on:refresh="forceRequestCostInfo">
        </operation-data>
      </el-tab-pane>

      <el-tab-pane label="库存管理" name="my-stocks">
        <oil-stock-management :provider-id="id"
                              :oil-types="oilTypes"
                              :oil-flows="oilFlows"
                              :oil-stocks="oilStocks"
                              :oil-update-histories="oilUpdateHistories"
                              :total-oil-update-histories-elements="totalOilUpdateHistoriesElements"
                              :oil-requests="oilRequests"
                              v-on:refresh="forceRequestStocks">
        </oil-stock-management>
      </el-tab-pane>

      <el-tab-pane label="余额变动" name="my-balance-history">
        <balance-change-history :data-list="balanceUpdateHistories"></balance-change-history>
      </el-tab-pane>

      <el-tab-pane label="团队信息" name="my-team-info">
        <team-info v-bind:data-list="teamInfo.teamMembers" v-bind:recommender="recommender" v-bind:provider-id="id"
                   v-bind:provider-list="recommendedProviders" v-on:refresh="forceRequestTeamInfo"></team-info>
      </el-tab-pane>

      <el-tab-pane label="管辖区域" name="my-managed-regions">
        <managed-regions
          v-bind:refresh-times="managedRegionsPageRefreshTimes"
          v-bind:provider-id="id">
        </managed-regions>
      </el-tab-pane>
      <el-tab-pane label="备注说明" name="my-comment">
        <comment v-bind:provider-info="providerInfo">
        </comment>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import * as api from "@/js/api.js"
import BalanceChangeHistory from "./balance/BalanceChangeHistory"
import TeamInfo from "./team/TeamInfo"
import OilStockManagement from "./oil/OilStockManagement";
import OperationData from "./operation_data/OperationData";
import ManagedRegions from "./region/ManagedRegions";
import Comment from "./comment/Comment";

export default {
  name: "UserDetails",
  components: {
    OilStockManagement,
    BalanceChangeHistory,
    TeamInfo,
    OperationData,
    ManagedRegions,
    Comment
  },

  data() {
    return {
      id: '',
      imageTypes: {
        '1': '修理厂门头照',
        '2': '身份证正面照',
        '3': '身份证反面照',
        '4': '营业执照',
        '5': '资质证书',
        '6': '环境照'
      },
      providerTypeNames: {
        '1': '省代',
        '2': '城市合伙人',
        '3': '修理厂'
      },
      auditForm: {
        payType: '1', // 0：正常支付 1：不支付 2：线下支付
        comment: '',
        subType: '1', // 1: A类型修理厂 2: B类型修理厂 3: 只洗车不保养的店
        approve: '1',
      },

      activeName: 'basic',
      providerInfo: {},
      providerOwner: {},
      imageList: {},

      costInfo: null,
      costInfoRequested: false,

      incomes: [],
      totalIncomesElements: 0,
      incomesRequested: false,

      oilTypes: [],
      oilStocks: [],
      oilUpdateHistories: [],
      totalOilUpdateHistoriesElements: 0,
      oilFlows: [],
      oilRequests: [],
      oilStocksRequested: false,

      totalMaintainElements: 0,
      maintains: [],

      balanceUpdateHistories: [],
      balanceUpdateHistoriesRequested: false,

      teamInfo: {},
      recommendedProviders: [],
      recommender: '0',
      teamInfoRequested: false,
      regionNameMappings: null,

      managedRegionsPageRefreshTimes: 0,
    }
  },

  methods: {
    confirmUpdateBalance() {
      const params = {
        providerId: this.id,
        balance: this.providerInfo.balance
      }

      api.providerUpdateBasicInfo(params).then(res => {
        let result = res.data
        if (result.error) {
          this.$message.error(result.error)
        } else {
          this.$message.success('操作成功')
          this.requestProviderInfo()
        }
      })
    },

    confirmOffline() {
      const params = {
        providerId: this.id
      }

      api.providerOffline(params).then(res => {
        let result = res.data
        if (result.error) {
          this.$message.error(result.error)
        } else {
          this.$message.success('操作成功')
          this.requestProviderInfo()
        }
      })
    },

    onAudit() {
      const params = {
        payType: this.auditForm.payType,
        subType: this.auditForm.subType,
        comment: this.auditForm.comment,
        approve: this.auditForm.approve,
        providerId: this.id,
        type: this.providerInfo.types
      }

      api.providerAudit(params).then(res => {
        let result = res.data
        if (result.error) {
          this.$message.error(result.error);
        } else {
          this.$message.success('操作成功')
          this.requestProviderInfo()
        }
      })
    },

    handleClick() {
      if (this.activeName === 'income-details') {
        this.requestIncomes()
        this.initRequestMaintains()
        this.requestCostInfo()
      } else if (this.activeName === 'my-stocks') {
        this.requestStocks()
      } else if (this.activeName === 'my-balance-history') {
        this.requestBalanceUpdateHistory()
      } else if (this.activeName === 'my-team-info') {
        this.requestTeamInfo()
      } else if (this.activeName === 'my-managed-regions') {
        this.managedRegionsPageRefreshTimes += 1;
      }
    },

    forceRequestCostInfo() {
      this.costInfoRequested = false
      this.requestCostInfo()
    },

    requestCostInfo() {
      if (!this.costInfoRequested && this.id !== '') {
        const params = {
          providerId: this.id,
        }
        api.providerCostInfo(params).then(res => {
          let result = res.data
          if (result.error) {
            this.$message.error('后台服务出错');
          } else {
            this.costInfo = result.data
            this.costInfoRequested = true
          }
        })
      }
    },

    requestIncomes() {
      if (!this.incomesRequested && this.id !== '') {
        const param = {
          providerId: this.id,
          page: 1,
          pageSize: 500,
        }
        api.providerIncomes(param).then(res => {
          let result = res.data
          if (result.error) {
            this.$message.error('后台服务出错');
          } else {
            this.incomes = result.data
            this.totalIncomesElements = this.incomes.length;
            this.incomesRequested = true
          }
        })
      }
    },

    onMaintainListPageChange(form) {
      const params = {
        providerId: this.id,
        page: form.page,
        pageSize: form.pageSize,
        status: 1,
      }
      this.doRequestMaintains(params);
    },

    initRequestMaintains() {
      if (this.id !== '') {
        const params = {
          providerId: this.id,
          status: 1,
          page: 1,
          pageSize: 20
        }
        this.doRequestMaintains(params);
      }
    },

    doRequestMaintains(params) {
      api.providerMaintains(params).then(res => {
        let result = res.data
        if (result.error) {
          this.$message.error('后台服务出错');
        } else {
          this.maintains = result.data.content;
          this.totalMaintainElements = result.data.totalElements;
        }
      });
    },

    requestProviderInfo() {
      const params = {
        providerId: this.id
      }
      api.getProviderById(params).then(res => {
        let result = res.data
        if (result.error) {
          this.$message.error('后台服务出错');
        } else {
          this.providerInfo = result.data
        }
      })

      api.getProviderOwner(params).then(res => {
        let result = res.data
        if (result.error) {
          this.$message.error('后台服务出错');
        } else {
          this.providerOwner = result.data
        }
      })
    },

    forceRequestStocks() {
      this.oilStocksRequested = false
      this.requestStocks()
    },

    requestStocks() {
      if (!this.oilStocksRequested && this.id !== '') {
        const params = {
          providerId: this.id,
        }

        api.providerOilStock(params).then(res => {
          let result = res.data
          if (result.error) {
            this.$message.error('后台服务出错');
          } else {
            this.oilStocksRequested = true
            this.oilStocks = result.data
          }
        })

        api.providerOilStockUpdateHistories(params).then(res => {
          let result = res.data
          if (result.error) {
            this.$message.error('后台服务出错');
          } else {
            this.oilUpdateHistories = result.data
            this.totalOilUpdateHistoriesElements = this.oilUpdateHistories.length
          }
        })

        api.providerStockFlow(params).then(res => {
          let result = res.data
          if (result.error) {
            this.$message.error('后台服务出错');
          } else {
            this.oilFlows = result.data
          }
        })

        api.providerAllOilRequests(params).then(res => {
          let result = res.data
          if (result.error) {
            this.$message.error('后台服务出错');
          } else {
            this.oilRequests = result.data
          }
        })

        api.providerOilTypes({}).then(res => {
          let result = res.data
          if (result.error) {
            this.$message.error('后台服务出错');
          } else {
            result.data.sort((x, y) => x.sort - y.sort)
            this.oilTypes = result.data
          }
        })
      }
    },

    requestBalanceUpdateHistory() {
      if (!this.balanceUpdateHistoriesRequested && this.id !== '') {
        this.balanceUpdateHistoriesRequested = true;

        const params = {
          providerId: this.id
        }

        api.providerBalanceUpdateHistory(params).then(res => {
          let result = res.data
          if (result.error) {
            this.$message.error('后台服务出错');
          } else {
            this.balanceUpdateHistories = result.data
          }
        })
      }
    },

    forceRequestTeamInfo() {
      this.teamInfoRequested = false
      this.requestTeamInfo()
    },

    requestTeamInfo() {
      if (!this.teamInfoRequested && this.id !== '') {
        this.teamInfoRequested = true;
        const params = {
          providerId: this.id
        }
        api.providerTeamInfo(params).then(res => {
          let result = res.data
          if (result.error) {
            this.$message.error('后台服务出错');
          } else {
            this.teamInfo = result.data
            if (this.teamInfo.mapping) {
              if (this.teamInfo.mapping.provinceAgentId > 0) {
                this.recommender = this.teamInfo.mapping.provinceAgentId
              } else {
                this.recommender = this.teamInfo.mapping.regionAgentId              }
            }
          }
        })

        api.providerRecommendedProviders(params).then(res => {
          let result = res.data
          if (result.error) {
            this.$message.error('后台服务出错');
          } else {
            this.recommendedProviders = result.data
          }
        })
      }
    }
  },

  mounted() {
    this.id = this.$route.query.id
    if (this.id === undefined || this.id === null) {
      this.id = ''
    }
    if (this.id != '') {
      const params = {
        providerId: this.id
      }
      this.requestProviderInfo()
      api.getProviderImages(params).then(res => {
        let result = res.data
        if (result.error) {
          this.$message.error('后台服务出错');
        } else {
          this.imageList = result.data
        }
      })
    }
  },
}
</script>

<style scoped>
.margin-top {
  margin-top: 20px;
}
</style>



// WEBPACK FOOTER //
// src/pages/providers/ProviderDetails.vue